module.exports = __webpack_public_path__ + "static/polarpumpen-hero-4cbe976c2598c7e2846f5c4916dd2382.jpg";